import { c as _c } from "react/compiler-runtime";
import { toastIconRecipe } from './styles';
import type { SnackbarType } from './types';
export function ToastIcon(t0) {
  const $ = _c(3);
  const {
    type
  } = t0;
  switch (type) {
    case "error":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <span className={toastIconRecipe({
            type: "error"
          })} aria-hidden="true">!</span>;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "success":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <span className={toastIconRecipe({
            type: "success"
          })} aria-hidden="true">✓</span>;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <span className={toastIconRecipe({
            type: "info"
          })} aria-hidden="true">i</span>;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
  }
}